import { useEffect, useState } from 'react';
import { logIn } from '@fingo/lib/apollo/helpers/auth';

const useWidgetAuth = () => {
  const [isLoading, setIsLoading] = useState(true);
  const handleMessage = ({ data }) => {
    const { value, type } = data;
    switch (type) {
      case 'TOKEN':
        logIn(value);
        break;
      default:
    }
    setIsLoading(false);
  };
  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  return isLoading;
};

export default useWidgetAuth;
